// Application constants
export const SITE_NAME = 'amovent.com';

/**
 * Constructs a page title with the format: "Page Name - amovent.com"
 * @param pageName - The name of the current page (e.g., "Events", "Place", "Home")
 * @returns The formatted page title
 */
export const getPageTitle = (pageName: string): string => {
  return `${pageName} - ${SITE_NAME}`;
};